/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.21/esri/copyright.txt for details.
*/
const d="20210928",c="c312c4b5c1d3a2f6febbd67d710c6d6cd2dba51d";export{d as buildDate,c as commitHash};
